import NextScript from 'next/script';

import { useCurrentSite } from '../../providers/currentSite/useCurrentSite';

import { getGTMId, getGTMServerId } from './GTM';

interface Props {
    gtmData: {
        [key: string]: unknown;
    };
}

export function GTMScript({ gtmData }: Props) {
    const { currentSite } = useCurrentSite();

    const initialData = JSON.stringify(gtmData);
    const gtmId = getGTMId();
    const gtmServerId = getGTMServerId();
    const { gtmServer } = currentSite;

    return (
        <>
            <NextScript
                id="gtmScript"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `window.dataLayer=window.dataLayer||[];window.dataLayer.push(${initialData});
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
j.async=false;j.defer=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`,
                }}
            />
            <noscript>
                <iframe
                    src={`//www.googletagmanager.com/ns.html?id=${gtmId}`}
                    height="0"
                    width="0"
                    title="Google Tag Manager"
                    // eslint-disable-next-line react/forbid-dom-props
                    style={{
                        display: 'none',
                        visibility: 'hidden',
                    }}
                />
            </noscript>
            <NextScript
                id="gtmServerScript"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
j.async=true;j.src='https://${gtmServer.host}/08iry9bm4dptzgv.js?awl='+i.replace(/^GTM-/, '')+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmServerId}');`,
                }}
            />
        </>
    );
}
